export default "__VITE_ASSET__6da9c359__"